import EditableText from './editable-text'
export * from './editable-text'
export default EditableText
